/**
 * Static example universe data used for the interactive universe preview
 * shown to signed-out users and users with no artists yet.
 *
 * Matches the full shape expected by buildUniverseLayout() so the preview
 * can use the real UniverseCanvas with pan, zoom, hover, and LOD rendering.
 */

const exampleUniverseData = {
  clusters: [
    {
      label: 'Indie / Alt',
      color: { h: 260, s: 60, l: 55 },
      topTags: ['indie', 'alternative', 'indie rock'],
      members: [
        { name: 'Radiohead', source: 'favorite', image: null },
        { name: 'Tame Impala', source: 'favorite', image: null },
        { name: 'Arctic Monkeys', source: 'favorite', image: null },
        { name: 'The Strokes', source: 'favorite', image: null },
        { name: 'Mac DeMarco', source: 'discovered', image: null },
        { name: 'Khruangbin', source: 'discovered', image: null },
      ],
      recommendations: [
        { name: 'King Gizzard', matchScore: 0.82, suggestedBy: ['Tame Impala', 'Radiohead'] },
        { name: 'Pond', matchScore: 0.76, suggestedBy: ['Tame Impala'] },
        { name: 'Temples', matchScore: 0.71, suggestedBy: ['Tame Impala', 'The Strokes'] },
        { name: 'Melody\'s Echo Chamber', matchScore: 0.68, suggestedBy: ['Tame Impala'] },
      ],
    },
    {
      label: 'Electronic',
      color: { h: 190, s: 70, l: 50 },
      topTags: ['electronic', 'synth', 'ambient'],
      members: [
        { name: 'Boards of Canada', source: 'favorite', image: null },
        { name: 'Aphex Twin', source: 'favorite', image: null },
        { name: 'Tycho', source: 'favorite', image: null },
        { name: 'Bonobo', source: 'discovered', image: null },
        { name: 'Four Tet', source: 'discovered', image: null },
      ],
      recommendations: [
        { name: 'Bibio', matchScore: 0.79, suggestedBy: ['Boards of Canada', 'Tycho'] },
        { name: 'Rival Consoles', matchScore: 0.72, suggestedBy: ['Tycho'] },
        { name: 'Clark', matchScore: 0.67, suggestedBy: ['Aphex Twin'] },
      ],
    },
    {
      label: 'Hip-Hop / R&B',
      color: { h: 30, s: 75, l: 55 },
      topTags: ['hip-hop', 'r&b', 'soul'],
      members: [
        { name: 'Frank Ocean', source: 'favorite', image: null },
        { name: 'Kendrick Lamar', source: 'favorite', image: null },
        { name: 'Tyler, the Creator', source: 'favorite', image: null },
        { name: 'Steve Lacy', source: 'discovered', image: null },
        { name: 'Daniel Caesar', source: 'discovered', image: null },
      ],
      recommendations: [
        { name: 'Sampha', matchScore: 0.85, suggestedBy: ['Frank Ocean'] },
        { name: 'Ravyn Lenae', matchScore: 0.74, suggestedBy: ['Steve Lacy', 'Frank Ocean'] },
        { name: 'Smino', matchScore: 0.70, suggestedBy: ['Tyler, the Creator'] },
        { name: 'Mereba', matchScore: 0.66, suggestedBy: ['Daniel Caesar'] },
      ],
    },
    {
      label: 'Pop',
      color: { h: 330, s: 60, l: 55 },
      topTags: ['pop', 'art pop', 'dream pop'],
      members: [
        { name: 'Lorde', source: 'favorite', image: null },
        { name: 'Charli XCX', source: 'favorite', image: null },
        { name: 'Caroline Polachek', source: 'favorite', image: null },
        { name: 'Weyes Blood', source: 'discovered', image: null },
      ],
      recommendations: [
        { name: 'Rina Sawayama', matchScore: 0.80, suggestedBy: ['Charli XCX'] },
        { name: 'Japanese Breakfast', matchScore: 0.75, suggestedBy: ['Lorde', 'Weyes Blood'] },
        { name: 'Magdalena Bay', matchScore: 0.69, suggestedBy: ['Caroline Polachek'] },
      ],
    },
  ],
  visualization: {
    width: 640,
    height: 460,
    clusterCenters: [
      { x: 160, y: 140, memberCount: 6, recCount: 4, color: { h: 260, s: 60, l: 55 } },
      { x: 440, y: 120, memberCount: 5, recCount: 3, color: { h: 190, s: 70, l: 50 } },
      { x: 300, y: 340, memberCount: 5, recCount: 4, color: { h: 30, s: 75, l: 55 } },
      { x: 520, y: 310, memberCount: 4, recCount: 3, color: { h: 330, s: 60, l: 55 } },
    ],
    // nodes/recLinks/bridgeLinks not needed — buildUniverseLayout builds these
    // from the clusters array above
    nodes: [],
    recLinks: [],
    bridgeLinks: [],
  },
  bridges: [],
  chainLinks: [],
  superclusters: [],
};

export default exampleUniverseData;
